<template>
    <div class="course_main">
        <!-- <el-row> -->
            <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="box-sizing: border-box;float: none;margin: 0 auto;"> -->
            <div class="warp_container clearfix">
                <div class="course_tit"></div>
                <div class="course_center_warp">
                    <div class="course_item_box" v-for="(val,key) in list_data" :key='key'>
                        <div @click="getCourse(key)" class="course_item cursor">
                            <div class="course_img_box"><img :src="val.course_img" alt=""></div>
                            <div class="item_tit">
                                <div class="item_txt_box"><div class="txt oh">{{val.course_name}}</div></div>
                                <div class="price">￥{{val.course_discount_price}}</div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <!-- </el-col> -->
        <!-- </el-row> -->
    </div>
</template>

<script>
    import store from '../store'
    export default {
        data () {
            return{
                list_data:''
            }
        },
        methods: {
            getData() {
                this.$http.get('/api/v2/course/getList')
                .then((res) => {
                    if(res.data.code===1){
                       this.list_data=res.data.data.data;
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            getCourse(index) {
                this.$router.push({name:'courseDescription', params: {course_id:this.list_data[index].course_id}})
            }   
        },
        created() {
            this.getData()
            store.commit('setNav',2);
        }
    }
</script>

<style scoped>
    .course_main{
        width: 100%;
        box-sizing: border-box;
        background: #f0f2f5;
        min-height: 80%;
    }
    .course_center_warp{
        width: 100%;
        box-sizing: border-box;
    }
    .course_item_box{
        width: 31.6%;
        box-sizing: border-box;
        float: left;
    }
    .course_item_box:nth-child(3n-1){
        margin: 0 2.6%;
    }
    .course_item{
        width: 100%;
        border-radius: 10px;
        margin-bottom: 30px;
        box-shadow:0px 5px 8px 2px rgba(50,51,51,0.2);
        background: #fff;
    }
    .course_img_box{
        width: 100%;
        height: 210px;
    }
    .course_item img{
        width: 100%;
        height: 210px;
        border-radius:10px 10px 0px 0px;
        box-shadow:0px 5px 8px 2px rgba(50,51,51,0.2);
    }
    .course_item .item_tit{
        width: 100%;
        height: 70px;
    }
    .course_tit{
        text-align: center;
        padding-top: 40px;
        padding-bottom: 40px;
        font-size: 32px;
        color: #333;
        
    }
    .item_tit{
        padding: 0 10px;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        position: relative;     
    }
    .item_txt_box{
        height: 68px;
        margin-right: 100px;
        overflow: hidden;
    }
    
    .price{
        color: #FF6029;
        font-size: 30px;
        float: right;
        line-height: 70px;
        position: absolute;
        right: 10px;
        top: 0;
    }
    .txt{
        padding-top: 13px;
        font-size: 20px;
        float: left;
        line-height: 22px;
    }
    
</style>


// WEBPACK FOOTER //
// src/page/CourseList.vue